import { Products } from "./Products";
import { Sales } from "./Sales";
import { Shifts } from "./Shifts";
import { Settings } from "./Settings";
import { ChevronDown } from "./ChevronDown";
import { ChevronRight } from "./ChevronRight";
import { Check } from "./Check";
import { SearchData } from "./SearchData";
import { Reports } from "./Reports";
import { Heart } from "./Heart";
import { CompanyLogo } from "./CompanyLogo";
import { CompanyLogoLogin } from "./CompanyLogoLogin";
import { Logout } from "./Logout";
import { Search } from "./Search";
import { ArrowDown } from "./ArrowDown";
import { Plus } from "./Plus";
import { Home } from "./Home";
import { Answers } from "./Answers";
import { Liveboards } from "./Liveboards";
import { SpotIQ } from "./SpotIQ";
import { UpDownArrows } from "./UpDownArrows";
import { More } from "./More";
import { Cross } from "./Cross";
import { FavoriteEmpty } from "./FavoriteEmtpy";
import { FavoriteFilled } from "./FavoriteFilled";
import { Liveboard } from "./Liveboard";
import { Edit } from "./Edit";
import { CheckboxDefault } from "./CheckboxDefault";
import { CheckboxTicked } from "./CheckboxTicked";
import { Info } from "./Info";
import { MaintenanceTrip } from "./MaintenanceTrip";
import { Star } from "./Star";
import { SortHandle } from "./SortHandle";
import { CaretDown } from "./CaretDown";
import { DoubleChevronLeft } from "./DoubleChevronLeft";
import { Download } from "./Download";
import { Upload } from "./Upload";
import { File } from "./File";
import { Trash } from "./Trash";
import { Conversation } from "./Conversation";
import { HomeAlt } from "./HomeAlt";
import { BILogo } from "./BILogo";
import { ExclamationMark } from "./ExclamationMark";
import { User } from "./User";
import { Businesses } from "./Businesses";
import { Schedules } from "./Schedules";
import { Budget } from "./Budget";
import { Admin } from "./Admin";
import { NormalUser } from "./NormalUser";
import { RadioFilled } from "./RadioFilled";
import { RadioEmpty } from "./RadioEmpty";
import { Server } from "./Server";
import { Gift } from "./Gift";

const svgIconRegistry = {
  Sales,
  Shifts,
  Products,
  Settings,
  ChevronDown,
  ChevronRight,
  Check,
  SearchData,
  Reports,
  Heart,
  CompanyLogo,
  CompanyLogoLogin,
  Logout,
  Search,
  ArrowDown,
  Plus,
  Home,
  HomeAlt,
  Answers,
  Liveboards,
  SpotIQ,
  UpDownArrows,
  More,
  Cross,
  FavoriteEmpty,
  FavoriteFilled,
  Liveboard,
  Edit,
  CheckboxDefault,
  CheckboxTicked,
  Info,
  MaintenanceTrip,
  Star,
  SortHandle,
  CaretDown,
  DoubleChevronLeft,
  Download,
  Upload,
  File,
  Trash,
  Conversation,
  BILogo,
  ExclamationMark,
  User,
  Businesses,
  Schedules,
  Budget,
  Admin,
  NormalUser,
  RadioFilled,
  RadioEmpty,
  Server,
  Gift,
} as const;

export type SvgIconType = keyof typeof svgIconRegistry;

export type SvgIconProps = {
  icon: SvgIconType;
};

export function SvgIcon(props: SvgIconProps) {
  return svgIconRegistry[props.icon]();
}
